<template>
  <div style="">
    <div class="header-operate">
    </div>
    <div class="file_content">
      <a-spin :spinning="tableInfo.tableLoading">
        <a-list :data-source="tableInfo.tableData"
                 @tablePageChange="changeTable" :show-add="false" @rowClick="rowClick">
          <a-list-item slot="renderItem" :key="item.id" slot-scope="item,index">
            <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;height: 40px">
              <div style="width: 400px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                {{item.fileName}}
              </div>
              <div style="width: 200px;">
                {{item.createTime}}
              </div>
              <div >
                <pt-icon   style="margin-right: 15px;" type="icon-xiazai"  :title="$t('baseVO.download')"  @click.native="downLoadFile(item)">{{ $t('baseVO.download') }}</pt-icon>
                <pt-icon type="icon-tubiao" :title="$t('baseVO.delete')"  @click.native="deleteFile(item)">{{ $t('baseVO.delete') }}</pt-icon>
              </div>
            </div>
          </a-list-item>
        </a-list>
      </a-spin>
    </div>
    <div class="pageConent" style="display: flex;justify-content: flex-end">
      <a-pagination @change="changeTable" size="small" :total="tableInfo.pagination.total" :showTotal="tableInfo.pagination.showTotal" :pageSize="10" :current="queryVO.current" :hideOnSinglePage="true"></a-pagination>
    </div>

  </div>

</template>

<script>
  import {selectExportFileAll,deleteObj} from '@/api/sys/file'
  export default {
    name: 'TableList',
    components: {
    },
    data() {
      let _this = this;
      return {

        tableInfo: {
          tableData: [],
          pagination: {
            onChange: page => {
              _this.changeTable(page);
            },
            pageSize:10,
            total:1,
            size:'small',
            current:1,
            hideOnSinglePage:true,
            showTotal:(total)=>{
              return `共${total}条`
            }
          },
          tableLoading: true
        },
        queryVO:{
          current:1,
          type:'2',
        },
        drawerInfo:{
          visible:false,
        },
        modal: {
          visible: false,
          loading: false,
          type: 'add'
        },
        addModal: {},
        oldValue:null,
        isEidt:false,
      }
    },
    computed:{
      title(){
        return this.isEidt?this.$t('post.modal.edidtTitle'):this.$t('post.modal.title')
      },
    },
    mounted() {
      this.initTableData()
    },
    methods: {
      rowClick(row){

      },
      drawerInfoClose(){
        this.drawerInfo.visible = false
      },
      changeTable(page,pageSize){
        console.log("table change")
        this.queryVO.current = page
        this.initTableData()
      },
      keySearchEvent(value){
        this.queryVO.name = value
        this.initTableData()
      },
      changeCompany(){
        this.queryVO.current = 1
        this.tableInfo.pagination.current = 1
        this.initTableData()
      },
      initTableData() {
        this.tableInfo.tableLoading = true
        selectExportFileAll(this.queryVO).then(res => {
          this.tableInfo.tableLoading = false
          if (res.code == 1) {
            this.tableInfo.tableData = res.data.records
            this.tableInfo.pagination.total = res.data.total
          }
        }).catch(err => {
          this.tableInfo.tableLoading = false
        })
      },
      downLoadFile(row){
        this.$util.dowLoadFile(row.id,row.fileName,this);
      },
      deleteFile(row){
        let _this = this;
        this.$ptConfirm({
          title:"提示",
          content: '确定删除文件,删除后将不可恢复?',
          okType: 'primary',
          onOk() {
            deleteObj({idList:row.id}).then(res=>{
              if(res.code == 1){
                _this.$message.success("删除成功")
                _this.initTableData();
              }
            })
          },
          onCancel() {

          },
        });
      }
    }
  }
</script>
<style lang="less">

  @import "../../core/diy.less";

  .header-operate {
    background-color: @block-color;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
  }

  .file_content,.pageConent{
    margin: 20px 40px;
  }

  .file_content {
    padding: 20px 20px;
    border-radius: 4px;
    background-color: @block-color;
  }
</style>